export default {
    GET_SELECT_CLUB_MANAGER:(state)=>{
        return state.selectClubManager
    },
    GET_RESULT:(state)=>{
        return state.Result
    },
    GET_EDIT_CLUB_MANAGER:(state)=>{
        return state.editClubManager
    },
}
